import React from "react";
import {useFormik} from "formik";
import {MachineApiPut} from "./machine_api";
import * as yup from "yup";
import {
    Autocomplete,
    Box,
    Button,
    CardActions,
    CardContent,
    createFilterOptions,
    FormControl,
    FormControlLabel,
    Switch,
    TextField
} from "@mui/material";
import {Tables, TablesInsert} from "../../apitypes";


interface MachineFormProps {
    onSubmit: (values: MachineApiPut | TablesInsert<"machine">) => void
    onCancel: () => void
    object: MachineApiPut,
    isUpdating: boolean,
    workTasks: Tables<"workTask">[]|undefined
}

const MachineSchema = yup.object().shape({
    Code: yup.string().min(2).max(40).required(),
    Name: yup.string().required(),
    Active: yup.boolean().required(),
})

export default ({object, workTasks, onSubmit, onCancel, isUpdating}: MachineFormProps) => {
    const formik = useFormik<MachineApiPut>({
        initialValues: object,
        onSubmit: onSubmit,
        validationSchema: MachineSchema
    });

    return <Box component={"form"} className={"form-100"} onSubmit={formik.handleSubmit}>
        <CardContent>
            <TextField
                name={"Code"}
                id={"Code"}
                value={formik.values.Code}
                label={"Koda"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.Code && Boolean(formik.errors.Code)}
                helperText={formik.touched.Code && formik.errors.Code}
            />
            <TextField
                name={"Name"}
                id={"Name"}
                value={formik.values.Name}
                label={"Ime za prikaz"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.Name && Boolean(formik.errors.Name)}
                helperText={formik.touched.Name && formik.errors.Name}
            />

            <Autocomplete
                id={"workTask"}
                options={workTasks || []}
                autoSelect={true}
                value={formik.values.workTask}
                getOptionLabel={(option: Tables<"workTask">) => {
                    return option.Name + " (" + option.Code + ")";
                }}
                filterOptions={createFilterOptions({
                    stringify: (option) => option.Name + " " + option.Code,
                })}
                onChange={(event, newValue) => {
                    formik.setFieldValue("workTask", newValue);
                }}
                getOptionKey={(option) => option.id}
                renderInput={(params) => <TextField {...params} label="Privzeta operacija"/>}
                renderOption={(props, option: Tables<"workTask">) => {
                    const {key, ...rest} = props
                    return <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...rest} key={key}>
                        {option.Name} ({option.Code})
                    </Box>
                }}
            />

            <FormControl>
                <FormControlLabel label={"Active"} control={<Switch
                    id={"active"}
                    name={"active"}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    checked={formik.values.Active}
                />}/>
            </FormControl>


        </CardContent>
        <CardActions>
            <Button disabled={isUpdating} type={"submit"}>Shrani</Button>
            <Button onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Box>

}
